export const getTaxModule = (taxes, orderType) => {
  let tax = taxes.find((sinTax) => {
    return sinTax.taxModules.includes(orderType);
  });
  return +tax.taxValue;
};
